/**
 * selects logged user
 */

export const loggedUserDataSelector = ({ persistedData: { loggedUser } }) =>
  loggedUser;

export const loggedUserSelector = ({ persistedData: { loggedUser } }) =>
  loggedUser.id;
